import { Headline2, FlexCol } from 'components/Elements';
import { DOCUMENTS_URL } from 'lib/_api-helpers';
import { LearnerCardBase } from 'pages/learner/sharedStyles/LearnerStyles';
import styled from 'styled-components';
import { theme, sizes, breakpoints } from 'theme';
import strings from '../../strings/strings.json';

type BlueHeaderProps = {
    navBackButton: JSX.Element;
    logoS3Filepath: string | null;
    title: string;
};

export default function BlueHeader({ navBackButton, logoS3Filepath, title }: BlueHeaderProps) {
    return (
        <BlueHeaderBackground>
            <LimitedContainer>
                <BackButtonAndTitle>
                    <NavAndLogoContainer>
                        <NavButtonContainer>{navBackButton}</NavButtonContainer>
                        {logoS3Filepath && (
                            <LogoContainer>
                                <Image
                                    src={`${DOCUMENTS_URL}/${logoS3Filepath}`}
                                    alt={strings.organisationOverviewPage.logoAltText}
                                />
                            </LogoContainer>
                        )}
                    </NavAndLogoContainer>
                    <Headline2>{title}</Headline2>
                </BackButtonAndTitle>
            </LimitedContainer>
        </BlueHeaderBackground>
    );
}

const BlueHeaderBackground = styled.div`
    display: flex;
    justify-content: center;
    background: ${theme.orgAdminHeaderColour};
    width: 100%;
    min-height: 260px;
`;

const LimitedContainer = styled.header`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: space-between;
    gap: ${sizes.spacingMd};
    max-width: ${sizes.appMaxWidthWithoutPadding}px;
    padding: ${sizes.spacingLg} ${sizes.edgePadding};

    @media (max-width: ${breakpoints.sm}) {
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }
`;

const NavButtonContainer = styled.div`
    padding: 8px;
    width: fit-content;
    height: fit-content;
    background-color: ${theme.cardBackground};
    border-radius: ${sizes.borderRadiusXl};
    border: 1px solid ${theme.cardBorder};
`;

const BackButtonAndTitle = styled(FlexCol)`
    gap: ${sizes.spacingMd};
    width: 100%;
`;

const LogoContainer = styled(LearnerCardBase)`
    display: flex;
    align-items: center;
    height: auto;
    width: auto;
    max-width: max-content;
    max-height: max-content;

    padding: ${sizes.spacingSm};
    @media (max-width: ${breakpoints.md}) {
        align-self: flex-start;
    }
`;

const Image = styled.img`
    border-radius: ${sizes.borderRadiusMd};
    max-width: 244px;
    max-height: 88px;
    width: auto;
    height: auto;
    object-fit: contain;
`;

const NavAndLogoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;
